import React, { Component } from 'react'
import { PanelGroup, Panel } from 'react-bootstrap'
import MigrationKeyPanel from './MigrationKeyPanel'

class FlywheelFAQs extends Component{
	constructor(props){
		super(props)
		this.state = {}
		this.handleFAQSelect = this.handleFAQSelect.bind(this)
	}

	handleFAQSelect(activeFAQKey) {
		let _key = this.state.activeFAQKey
		if (_key && _key == activeFAQKey) {
			this.setState({ activeFAQKey: false })
		} else {
			this.setState({ activeFAQKey: activeFAQKey })
		}
	}

	render(){
		const { bvKeyMigrationEnabled } = this.props
		const { activeFAQKey } = this.state
		return (
			<div>
				<PanelGroup
					activeKey={activeFAQKey}
					onSelect={this.handleFAQSelect}
					bsClass="col-xs-10 col-md-10 bv-faq-accordion-list"
					id="flywheel"
					accordion
				>
					<Panel eventKey="1">
						<Panel.Heading bsClass="panel-heading">
							<Panel.Title toggle>
								<p className="bv-faq-que">
									{ this.state.activeFAQKey == "1" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
									What is Destination Site URL?
								</p>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							<p className="bv-faq-ans">
								Destination Site URL of the site you are moving to.
							</p>
						</Panel.Body>
					</Panel>

					<Panel eventKey="2">
						<Panel.Heading bsClass="panel-heading">
							<Panel.Title toggle>
								<p className="bv-faq-que">
									{ this.state.activeFAQKey == "2" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
									Where can I find my Flywheel URL?
								</p>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							<p className="bv-faq-ans">
								This is the URL that appears when you log in to your Flywheel account, and click on the destination site.
							</p>
						</Panel.Body>
					</Panel>

					<Panel eventKey="3">
						<Panel.Heading bsClass="panel-heading">
							<Panel.Title toggle>
								<p className="bv-faq-que">
									{ this.state.activeFAQKey == "3" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
									Where can I find my sFTP credentials?
								</p>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							<p className="bv-faq-ans">
								<strong>sFTP Username:</strong> Same as your Flywheel account username.{"\n"}
								<strong>sFTP Password:</strong> Same as your Flywheel account password.
							</p>
						</Panel.Body>
					</Panel>

					{bvKeyMigrationEnabled ? <MigrationKeyPanel eventKey='4' activeFAQKey={activeFAQKey} /> : null}
				</PanelGroup>
			</div>
		)
	}
}

export default FlywheelFAQs
